import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { Reset } from 'styled-reset';
import { Helmet } from 'react-helmet';
import theme from 'theme';
// import DINNextLTProReg from './assets/Linotype - DINNextLTPro-Regular.otf';
// import DINNextLTProUltraLight from './assets/Linotype - DINNextLTPro-UltraLight.otf';



const GlobalStyles = createGlobalStyle`
  @font-face {
  src: url('${process.env.ASSET_PREFIX}/Linotype - DINNextLTPro-Regular.otf');
    font-family: 'DINNextLTPro';
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    src: url('${process.env.ASSET_PREFIX}/Linotype - DINNextLTPro-UltraLight.otf');
    font-family: 'DINNextLTPro';
    font-weight: 200;
    font-style: normal;
  }
  body {
    margin: 0;
    text-align: center;
    height: 100%;
    min-height: 100%;
    background: rgba(0,0,0,0.5);
    overflow: hidden;
  }
`;

interface Props {
  children: React.ReactElement;
}

export default ({ children }:Props) => (
  <>
    <Helmet>
      <meta charSet="utf-8" />
      <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests" />
      <script>{`(function(w,d,s,l,i){w[l] = w[l] || [];w[l].push(
      {'gtm.start': new Date().getTime(),event:'gtm.js'}
              );var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-NJ8QLSW')`}</script>
    </Helmet>
    <noscript>
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NJ8QLSW"
      height="0" width="0" styles="display:none;visibility:hidden"></iframe>
    </noscript>
    <Reset />
    <GlobalStyles />
    <CookiesProvider>
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </CookiesProvider>
  </>
)
